<template>
	<app tabbar>
		<tab-list-m :tab="tabList" @change="updateList"></tab-list-m>
		<scroll-list-m ref="list">
			<template v-slot="{data}">
				<scroll-item-m>
					<div class="flex-between-center">
						<div class="info">申请时间：{{data.create_date}}</div>
						<div class="state"><span :style="{'color': claimState[data.state].color}">{{claimState[data.state].name}}</span></div>
					</div>
					<div class="name">{{data.project_name}}</div>
					<div class="info">金融机构：{{data.bxgs_name}}</div>
					<div class="info">保单金额：￥{{data.bd_money}}</div>
					<button-list-m slot="button">
						<c-button v-if="data.state == 3" @click="navigateTo('/claim_detail', {id: data.id})">确认完结</c-button>
						<c-button v-else color="gray" hollow @click="navigateTo('/claim_detail', {id: data.id})">查看详情</c-button>
					</button-list-m>
				</scroll-item-m>
			</template>
		</scroll-list-m>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		data() {
			return {
				tabList: [{
					name: '待确认理赔',
					param: {
						state: 3
					}
				}, {
					name: '理赔列表',
				}]
			}
		},
		
		computed: {
			...mapGetters(['claimState'])
		},
		
		methods: {
			updateList(data) {
				this.$refs.list.load({
					url: '/project/bxlp/list',
					data: data.param
				});
			}
		}
	};
</script>

<style lang="stylus" scoped>
</style>